import {Link} from "react-router-dom";
import {imageMap} from "../../images/imageMap.ts";

export default function WhatYouAreGettingSectionComponent() {
    return (
        <section className="section-includes">
            <div className="content content--narrow">
                <div className="blurb">
                    <h3 className="heading heading--big">Det får du med i dit abonnement</h3>
                </div>
                <ul className="grid grid-triple no-boxes">
                    <li>
                        <img src={imageMap.products.router_fiber2} alt="Zyxel router"/>
                    </li>
                    <li>
                        <p>
                            <strong>Router følger med</strong><br/>
                            Bestiller du fibernet fra Hiper får du en af markedets bedste og nyeste Zyxel routere med, som sikrer dig lynhurtigt internet.
                            Med routeren kan du selv vælge, om du vil benytte wifi i din bolig, eller om du ønsker en kablet LAN-forbindelse.
                        </p>
                        <Link to="/hjaelp/udstyr/hvilken-router-foelger-med">Læs mere om routeren</Link>
                    </li>
                </ul>
                <ul className="grid grid-triple no-boxes">
                    <li>
                        <img src={imageMap.products.mit_hiper} alt="Mit Hiper selvbetjening"/>
                    </li>
                    <li>
                        <p>
                            <strong>Adgang til egen selvbetjening</strong><br/>
                            Når du bestiller et abonnement hos Hiper, så får du adgang til din egen selvbetjening, Mit Hiper, hvor du kan finde dine regninger, skifte betalingskort m.m..
                        </p>
                    </li>
                </ul>
            </div>
        </section>
    )
}
